import { useEffect } from "react";

import ClientAvailability from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/ClientInfoV2/AvailabilitySection/ClientAvailability";
import CommunicationStatus from "../../../../../components/cm/Dashboard/FullPages/ClientDetail/ClientInfoV2/AvailabilitySection/CommunicationStatus";
import Navigation from "../../../../../components/navigations/client/detail/client-info/navigation";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { useQueryParams } from "../../../../../hooks/useQueryParams";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case, _clientId } = useParentLoaderData(2);
  const { updateFilter } = useQueryParams();

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/client-info/availability");
  }, []);

  useEffect(() => {
    if (_clientId !== null) {
      const current = new URL(window.location.href);
      const currentClient = current.searchParams.get("client");
      if (String(currentClient) !== String(_clientId)) {
        updateFilter("client", String(_clientId), null, true);
      }
    }
  }, [_clientId]);

  return (
    <Navigation activeTab="availability" _case={_case}>
      <div className="m-0 flex max-h-fit w-full flex-col items-center p-1">
        <div className="w-full">
          <CommunicationStatus caseObj={_case} />
          <ClientAvailability caseObj={_case} />
        </div>
      </div>
    </Navigation>
  );
};
